/**
 * 推广管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>推广管理<span style="color: #a7aab3;">（默认显示商务,如需查看全部请进行筛选）</span></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" style="width:120px" placeholder="输入用户名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:120px" placeholder="输入联系方式" clearable></el-input>
      </el-form-item>
       <el-form-item label="是否商务：">
        <el-select size="small" v-model="formInline.is_seller" style="width:80px" placeholder="请选择">
          <el-option v-for="type in seller" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择注册开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择注册结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="warning" title="显示商务推广操作页面" @click="handleSeller">商务推广</el-button>
        <el-button size="small" type="warning" title="显示年费订单操作页面" @click="handleFee">年费订单</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="uid" v-if="idShow">
      </el-table-column>
      <el-table-column prop="username" align="center" label="用户名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="real_name" align="center" label="真实姓名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pc_mobile" align="center" label="联系方式" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="attribution" align="center" label="号码归属地" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="pc_company" align="center" label="所属企业" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="mobile" align="center" label="头像" width="80px" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.pc_head">
        　  <img :src="scope.row.pc_head" width="40" height="40" class="head_pic"/>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="qq" align="center" label="QQ" show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="account_name" align="center" label="账户类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="is_seller_name" align="center" label="是否商务" width="90px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="integral" align="center" label="积分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="invite_num" align="center" label="推广总数" width="120px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="reg_time" align="center" label="注册时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleInfo(scope.$index, scope.row)" title="查看推广记录">推广记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form :inline="true" label-width="120px" :model="inviteForm" ref="infoForm">
        <el-form-item>
            <el-date-picker v-model="inviteForm.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择推广开始时间" :picker-options="pickerOptions"> </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-date-picker v-model="inviteForm.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择推广结束时间" :picker-options="pickerOptions"> </el-date-picker>
        </el-form-item>
        <el-form-item>
         <el-button size="small" type="primary" icon="el-icon-search" @click="searchInvite">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出</el-button>
        </el-form-item>
      </el-form>
            <div class="invite_item"> 
              <el-table size="small" ref="multipleTable" :data="logData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
                <el-table-column align="center" type="index" label="序号" width="50px">
                </el-table-column>
                <el-table-column prop="uid" v-if="idShow">
                </el-table-column>
                <el-table-column prop="name" align="center" label="用户名" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="invite_time" align="center" label="注册时间" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>   
    </el-dialog>

    <!-- 商务推广页面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="sellerFormVisible" width="60%" @click='closeDialog("sellerForm")' style="overflow: auto;">
      <el-form :inline="true" :model="sellerFormInline">
      <el-form-item label="搜索：">
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="sellerFormInline.start_date" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="sellerFormInline.end_date" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="searchSeller">搜索</el-button>
        <el-button size="small" type="warning" title="导出满足条件的所有数据" @click="exportSeller">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" ref="multipleTable" :data="sellerData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="real_name" align="center" label="姓名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="联系方式" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="invite_num" align="center" label="推广数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="order_fwf" align="center" label="订单服务费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="order_num" align="center" label="订单数" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    </el-dialog>

    <!-- 年费订单页面 -->
    <el-dialog v-dialogDrag :title="title" :close-on-click-modal="false" :visible.sync="feeFormVisible" width="60%" @click='closeDialog("feeForm")' style="overflow: auto;">
      <el-form :inline="true" :model="feeFormInline">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="feeFormInline.mobile" style="width:140px" placeholder="输入联系方式" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="feeFormInline.start_date" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="feeFormInline.end_date" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchFee">搜索</el-button>
          <el-button size="small" type="warning" title="导出满足条件的所有数据" @click="exportFee">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table size="small" ref="multipleTable" :data="feeData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
        <el-table-column align="center" type="index" label="序号" width="50px">
        </el-table-column>
        <el-table-column prop="zlmc" align="center" label="专利名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zlbh" align="center" label="专利号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="total_fee" align="center" label="订单总费用" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="order_fwf" align="center" label="服务费" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="promote_name" align="center" label="邀请人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="promote_mobile" align="center" label="邀请人号码" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="wx_name" align="center" label="缴费人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mobile" align="center" label="缴费人号码" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="attribution" align="center" label="号码归属地" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="pay_time" align="center" label="支付时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="invoice_info" align="center" label="发票信息" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="fee_string" align="center" label="缴费明细" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { webInviteList, webExportInviteLog, webUrl, webDownloadUserExcel, webUserInviteList,
getSellerInviteList, getFeeInviteOrderList, exportSellerInvite, exportFeeInviteOrder } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      sellerFormVisible: false, //控制商务推广页面显示与隐藏
      feeFormVisible: false, //控制年费订单页面显示与隐藏
      excelFormVisible: false, //控制批量导入页面显示与隐藏
      sendCheckFormVisible: false, //控制发送消息(群发)页面显示与隐藏
      sellerCheckFormVisible: false, //控制商务设置页面显示与隐藏
      title: '推广记录',
      sendTitle: '',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      infoForm: {
        id: '',
        mobile: '',
        name: '',
        reg_time: '',
        address: '',
        head: '',
        token: localStorage.getItem('logintoken')
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        name: '',
        mobile: '',
        is_seller: 2
        // token: localStorage.getItem('logintoken')
      },
      //商务推广数据
      sellerFormInline: {
        start_date: '',
        end_date: ''
      },
      //年费订单数据
      feeFormInline: {
        start_date: '',
        end_date: '',
        mobile: ''
      },
      inviteForm: {
        uid: 0,
        start_time: '',
        end_time: '',
      },
      sendForm: {
        uid: '',
        title: '',
        content: ''
      },
      seller: [
        { key: '全部', value: 0 },
        { key: '是', value: 2 },
        { key: '否', value: 1 }
      ],
      sendCheckForm: {
        ids: '',
        title: '',
        content: ''
      },
      sellerCheckForm: {
        user_id : 0,
        is_seller: 1
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/users/importUserExcel',
      userparm: [], //搜索权限
      listData: [], //用户数据
      sellerData: [], //商务推广数据
      feeData: [], //年费订单数据
      logData: [], //推广记录数据
      invite_num: 0,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      sendFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '200个字符以内', trigger: 'blur' },
        ]
      },
      sendCheckFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '200个字符以内', trigger: 'blur' },
        ]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {


    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/users/importUserExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        if(parameter.start_time == null){
              parameter.start_time = ''
        }
        if(parameter.end_time == null){
              parameter.end_time = ''
        }
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webInviteList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 查询商务推广数据
    searchSeller(){
      let param = this.sellerFormInline
      if(param.start_date == null){
          param.start_date = ''
      }
      if(param.end_date == null){
          param.end_date = ''
      }
      if(param.start_date == '' || param.end_date == ''){
          this.$message({
            type: 'info',
            message: '请选择开始和结束时间!'
          })
          return false
      }
      getSellerInviteList(param)
      .then(res => {
          this.loading = false
          if (res.code == 200) {
            this.sellerData = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },
    // 查询推广年费订单数据
    searchFee(){
      let param = this.feeFormInline
      if(param.start_date == null){
          param.start_date = ''
      }
      if(param.end_date == null){
          param.end_date = ''
      }
      if(param.start_date == '' || param.end_date == '' || param.mobile == ''){
          this.$message({
            type: 'info',
            message: '请填写查询条件!'
          })
          return false
      }
      getFeeInviteOrderList(param)
      .then(res => {
          this.loading = false
          if (res.code == 200) {
            this.feeData = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },
    // 导出商务推广数据
    exportSeller(){
     let param = this.sellerFormInline
      if(param.start_date == null){
          param.start_date = ''
      }
      if(param.end_date == null){
          param.end_date = ''
      }
      if(param.start_date == '' || param.end_date == ''){
          this.$message({
            type: 'info',
            message: '请选择开始时间和结束时间!'
          })
          return false
      }
      this.$confirm('确定导出查询数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        exportSellerInvite(param)
        .then(res=>{
          if(res.code == 200){
            window.location.href = res.data.url
          }else{
            this.$message({
            type: 'error',
            message: res.msg
          })
          }
        })

      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 导出推广年费订单数据
    exportFee(){
      let param = this.feeFormInline
      if(param.start_date == null){
          param.start_date = ''
      }
      if(param.end_date == null){
          param.end_date = ''
      }
      if(param.start_date == '' || param.end_date == '' || param.mobile == ''){
          this.$message({
            type: 'info',
            message: '请填写查询条件!'
          })
          return false
      }
      this.$confirm('确定导出查询数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        exportFeeInviteOrder(param)
        .then(res=>{
          if(res.code == 200){
            window.location.href = res.data.url
          }else{
            this.$message({
            type: 'error',
            message: res.msg
          })
          }
        })

      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1,
      this.formInline.ps = 10,
      this.getdata(this.formInline)
    },
    // 推广记录搜索
    searchInvite() {
        if(this.inviteForm.start_time == null){
            this.inviteForm.start_time = ''
        }
        if(this.inviteForm.end_time == null){
            this.inviteForm.end_time = ''
        }
      webUserInviteList(this.inviteForm)
        .then(res => {
          res = checkLogin(res)
          if (res.code == 200) {
              console.log(res)
              this.logData = res.data.list
              this.invite_num = res.data.num
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.uid)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
    //添加提示框，确定后再导出，防止乱点，减轻服务器压力
    this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr) 
          window.location.href = webUrl + "/admin/patent/exportUserExcel?ids=" + idStr
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
           if(this.inviteForm.start_time == null){
                this.inviteForm.start_time = ''
           }
           if(this.inviteForm.end_time == null){
                this.inviteForm.end_time = ''
           }
        webExportInviteLog(this.inviteForm)
        .then(res => {
          res = checkLogin(res)
          if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: '导出成功!'
                })
            window.location.href = res.data.url
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    sendAll() {
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.uid)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      this.sendCheckFormVisible = true
      this.sendCheckForm.ids = JSON.stringify(idsArr)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
    if(row.invite_num <= 0){
        this.$message({
            type: 'info',
            message: '推广记录为空!'
        })
        return false
    }
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
      this.inviteForm.uid = row.uid
      console.log(row)
      // 查询用户推广记录
      webUserInviteList({'uid':row.uid})
        .then(res => {
          res = checkLogin(res)
          if (res.code == 200) {
              console.log(res)
              this.logData = res.data.list
              this.invite_num = res.data.num
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })

    },
    //显示商务推广页面
    handleSeller() {
      this.title = '商务推广数据查询及导出'
      this.sellerFormVisible = true
    },
    //显示年费订单页面
    handleFee(){
      this.title = '年费订单数据查询及导出'
      this.feeFormVisible = true
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'editForm'){
        this.editFormVisible = false
      }else if(formName == 'sellerForm'){
        this.sellerFormVisible = false
      }else if(formName == 'feeForm'){
        this.feeFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
    // 下载用户导入excel模板
    downloadExcel(){
      webDownloadUserExcel()
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '模板下载成功!'
              })
              window.location.href = res.data.value
          } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.invite_item {
  height: 600px;
  overflow-y: auto;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/user/invite.vue